var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.667 14.534V5.467c0-2-.854-2.8-2.974-2.8h-5.386c-2.12 0-2.974.8-2.974 2.8v9.067c0 2 .854 2.8 2.974 2.8h5.386c2.12 0 2.974-.8 2.974-2.8M14.667 17.467v9.067c0 2-.854 2.8-2.974 2.8H6.307c-2.12 0-2.974-.8-2.974-2.8v-9.067c0-2 .854-2.8 2.974-2.8h5.386c2.12 0 2.974.8 2.974 2.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M28.667 26.533V22.8c0-2-.854-2.8-2.974-2.8h-5.386c-2.12 0-2.974.8-2.974 2.8v3.733c0 2 .854 2.8 2.974 2.8h5.386c2.12 0 2.974-.8 2.974-2.8M14.667 9.2V5.467c0-2-.854-2.8-2.974-2.8H6.307c-2.12 0-2.974.8-2.974 2.8V9.2c0 2 .854 2.8 2.974 2.8h5.386c2.12 0 2.974-.8 2.974-2.8",
    opacity: 0.35
  })));
};
export default SvgGrid;